var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.26 75.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5f1fb;}.cls-2{fill:none;stroke:#231f20;stroke-miterlimit:10;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hailAsset 153colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.88,21.85A9.81,9.81,0,0,0,71,18.19,9.56,9.56,0,0,0,68.56,16a10.43,10.43,0,0,0-4.12-1.51.93.93,0,0,1-.54-.53A10,10,0,0,0,53.2,7.39a17.43,17.43,0,0,0-3.55.93,1.07,1.07,0,0,1-1.18-.41A11.78,11.78,0,0,0,43.87,4a13.08,13.08,0,0,0-2-.79c-.36-.1-.72-.2-1.1-.28a10.08,10.08,0,0,0-3-.18,12.07,12.07,0,0,0-1.2.14c-.57.09-1,.19-1.15.23l-.12,0a21.19,21.19,0,0,0-4.17,2,29.79,29.79,0,0,0-3.42,3.34l-.1,0a11.53,11.53,0,0,0-5.18-1.33,9.8,9.8,0,0,0-4.56,1.09,10.65,10.65,0,0,0-4.72,5,2.17,2.17,0,0,1-1.34,1,11.16,11.16,0,0,0-2.84,1,9.44,9.44,0,0,0-3.54,3.15c-.15.21-.29.42-.43.65a11.72,11.72,0,0,0-1.32,3.4,8.85,8.85,0,0,0,0,3.35A10,10,0,0,0,12,34a1.15,1.15,0,0,1,1,.84,10,10,0,0,0,8.3,6.39,9.92,9.92,0,0,0,5.72-1,1,1,0,0,1,1.25.31,12.48,12.48,0,0,0,20.18.11,1,1,0,0,1,1.25-.32,10.15,10.15,0,0,0,14.14-5.51.84.84,0,0,1,.78-.57A10,10,0,0,0,72.88,21.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.4,22.15a9.69,9.69,0,0,0-1.72-3.46,10.33,10.33,0,0,0-3.24-2.93,10.58,10.58,0,0,0-3.7-1.24,1,1,0,0,1-.56-.55,10.26,10.26,0,0,0-11-6.7,16.1,16.1,0,0,0-3.36.89,1.4,1.4,0,0,1-1.58-.49A12.34,12.34,0,0,0,43.66,3.8a13.2,13.2,0,0,0-2.1-.8c-.36-.11-.73-.21-1.12-.29a10.53,10.53,0,0,0-3-.17,12,12,0,0,0-1.22.15A11,11,0,0,0,35,3a22.08,22.08,0,0,0-4.32,2.16,30.78,30.78,0,0,0-3.48,3.47l-.1-.05a11.55,11.55,0,0,0-5.3-1.35A9.79,9.79,0,0,0,17.1,8.33a11.12,11.12,0,0,0-5,5.62,1.12,1.12,0,0,1-.76.6A11.52,11.52,0,0,0,8,15.63a9.65,9.65,0,0,0-3.6,3.28c-.15.22-.3.44-.44.68a12.13,12.13,0,0,0-1.33,3.53,9.24,9.24,0,0,0,0,3.47,10.32,10.32,0,0,0,8.51,8.49,1.19,1.19,0,0,1,1,.86,10.24,10.24,0,0,0,8.51,6.59,10,10,0,0,0,5.47-.85,1.55,1.55,0,0,1,1.9.48,12.67,12.67,0,0,0,20.14,0,1.57,1.57,0,0,1,1.91-.5,10.32,10.32,0,0,0,14-6,.85.85,0,0,1,.79-.6A10.36,10.36,0,0,0,73.4,22.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.57,
    cy: 58.48,
    r: 5.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.57,
    cy: 58.48,
    r: 5.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.57,
    cy: 63.44,
    r: 9.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 47.57,
    cy: 63.44,
    r: 9.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHail);
export default __webpack_public_path__ + "static/media/hail.3889cfa8600afb2befbeb282570f07e4.svg";
export { ForwardRef as ReactComponent };